// sipPublish function added for echo test - 23-08-24 - Dev Srini

import { useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Typography, Grid, } from '@material-ui/core'
import styles from './dashboardStyles'

import EchoSoundTest from './EchoSoundTest'

const CallInterface = ({ classes, dispatch }) => {
    const [soundModal, setSoundModal] = useState(false)
    const [playButton, setPlayButton] = useState(false)
    const [unclearVoice, setUnClearVoice] = useState(false)
    const [echoTest, setEchoTest] = useState(true)      

     // Updated the SIP function to use async/await and added error handling - 15/10/24 - Dev Srini
    const handleOpenSoundModal = async () => {
        setSoundModal(true)

        try {
            await window.sipPublish('closed', 'Busy', 'I am with client call')
            console.log("SIP status published successfully: 'Busy' - 'I am with client call'.")

            dispatch({
                type: 'SET_AGENT_PUBLISH_STATS',
                payload: 'closed'
            })
        } 
        catch (error) {
            console.error('Failed to publish SIP status:', error)
        }
    }

    const handleCloseSoundModal = async () => {
        setSoundModal(false)
        setPlayButton(false)
        setUnClearVoice(false)

        try {
            await window.sipPublish('open', 'Idle', 'I am Idle')
            console.log("SIP status published successfully: 'Idle' - 'I am Idle'.")

            dispatch({
                type: 'SET_AGENT_PUBLISH_STATS',
                payload: 'open'
            })
        } 
        catch (error) {
            console.error('Failed to publish SIP status:', error)
        }
        

        if (echoTest) {
            setEchoTest(false)

            try {
                await window.sipHangUp()
                console.log("SIP session hung up successfully.")
            } 
            catch (error) {
                console.error('Failed to hang up SIP session:', error)
            }
        }
    }

    const handleEchoTest = async () => {
        setPlayButton(true)
        setEchoTest(true)

        const phoneNumber = "9196"
        window.txtPhoneNumber.value = phoneNumber

        try {
            await window.sipCall()
            console.log("SIP call initiated successfully.")
        } catch (error) {
            console.error('Failed to initiate SIP call:', error)
        }
    }

    const handleHangup = async () => {
        setEchoTest(false)

        try {
            await window.sipHangUp()
            console.log("SIP session hung up successfully.")

            try {
                await window.sipPublish('open', 'Idle', 'I am Idle');
                console.log("SIP status published successfully: 'Idle' - 'I am Idle'.")

                dispatch({
                    type: 'SET_AGENT_PUBLISH_STATS',
                    payload: 'open'
                })
            }
            catch (publishError) {
                console.error('Failed to publish SIP status:', publishError)
            }

            handleCloseSoundModal()
        }

        catch (error) {
            console.error('Failed to hang up SIP session:', error)
        }
    }

    const handleUnClearVoice = () => {
        setUnClearVoice(true)
    }

    return (
        <div >
            <Grid 
                style={{ display: 'flex', cursor: 'pointer', margin: '15px', marginLeft: '-15px' }} 
                onClick={ handleOpenSoundModal }
            >
                <img
                    src={require('../../../../ui-assets/Ellipse.png')}
                    alt=" Agent Icon"
                    style={{
                        width: '35px', height: '35px', flexShrink: '0', borderRadius: '35px',
                        background: 'url(<path-to-image>) lightgray 50% / cover no-repeat',
                        marginRight: '10px', marginLeft: '120px'
                    }}
                />

                <Typography className={classes.soundtest_heading}  >
                    Echo/Sound Test
                </Typography>
            </Grid>

            <EchoSoundTest 
                soundModal={soundModal}
                playButton={playButton}
                unclearVoice={unclearVoice}
                handleEchoTest={handleEchoTest}
                handleHangup={handleHangup}
                handleUnClearVoice={handleUnClearVoice}
                handleCloseSoundModal={handleCloseSoundModal}
            />

        </div>
    )
}

export default withStyles(styles)(CallInterface)